<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.demandaTipos"
                            @change="handledemandaTipoChange"
                            default-option-text="Todas"
                            label="Tipo de demanda"
                            show-default-option
                            v-model="model.demandaTipo"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.agendamentoTipos"
                            @change="handleAgendamentoTipoChange"
                            default-option-text="Todos"
                            label="Tipo de agendamento"
                            show-default-option
                            text-field="nome"
                            v-model="model.agendamentoTipoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.municipios"
                            @change="handleMunicipioChange"
                            default-option-text="Todos"
                            label="Municipio"
                            show-default-option
                            text-field="nome"
                            v-model="model.municipioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.especialidades"
                            @change="handleEspecialidadeChange"
                            default-option-text="Todas"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :options="form.status"
                            @change="handleStatusChange"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            text-field="nome"
                            v-model="model.status"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="data">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="data.itens"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    @sort-changed="onSortChanged"
                    hide-filters
                    hide-pagination
                />
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Totais"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.agendado"
                            disabled
                            label="Agendado"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.realizado"
                            disabled
                            label="Realizado"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.reagendadoPaciente"
                            disabled
                            label="Reagendado pelo paciente"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.reagendadoMedico"
                            disabled
                            label="Reagendado pelo médico"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.canceladoPaciente"
                            disabled
                            label="Cancelado pelo paciente"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.canceladoMedico"
                            disabled
                            label="Cancelado pelo médico"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.faltaPaciente"
                            disabled
                            label="Falta do paciente"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.faltaMedica"
                            disabled
                            label="Falta do médico"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="data.totalizadores.aberto"
                            disabled
                            label="Em aberto"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="data.totalizadores.geral"
                            disabled
                            label="Total geral"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        fields() {
            return [
                {key: 'data', label: 'Data', sortable: true},
                {key: 'demandaTipoNome', label: 'Tipo de demanda', sortable: true},
                {key: 'agendamentoTipoNome', label: 'Tipo de agendamento', sortable: true},
                {key: 'municipioNome', label: 'Município', sortable: true},
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                {key: 'especialidadeNome', label: 'Especialidade', sortable: true},
                {key: 'usuarioNome', label: 'Médico', sortable: true},
                {key: 'agendamentoStatusNome', label: 'Status', sortable: true},
                {key: 'quantidade', label: 'Quantidade'},
            ]
        },
        validations() {
            return {
                periodo: {required: true},
                demandaTipo: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.ambulatorio'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            relatorioEstatisticoConsulta: this.getConectaSusRepository('ambulatorio.relatorioEstatisticoConsulta'),
        }

        this.load()
    },
    data() {
        return {
            data: null,
            form: null,
            model: null,
            others: {moment},
            sortBy: 'data',
            sortDesc: false,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioEstatisticoConsulta.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            this.data = null

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                demandaTipo: this.model.demandaTipo,
                agendamentoTipoId: this.model.agendamentoTipoId,
                municipioId: this.model.municipioId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                status: this.model.status,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoConsulta.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null

            this.data = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                demandaTipo: this.model.demandaTipo,
                agendamentoTipoId: this.model.agendamentoTipoId,
                municipioId: this.model.municipioId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                status: this.model.status,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.impressao.relatorioEstatisticoConsulta(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                demandaTipo: this.model.demandaTipo,
                agendamentoTipoId: this.model.agendamentoTipoId,
                municipioId: this.model.municipioId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                status: this.model.status,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.exportacao.relatorioEstatisticoConsulta(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handledemandaTipoChange(value) {
            this.form.agendamentoTipos = []
            this.form.municipios = []
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []
            this.model.agendamentoTipoId = null
            this.model.municipioId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.status = null
            this.data = null

            const request = {
                listar: 'agendamento-tipos',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                demandaTipo: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoConsulta.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.agendamentoTipos = Object.assign(response.data.agendamentoTipos)
                    this.form.municipios = Object.assign(response.data.municipios)
                    this.form.unidades = Object.assign(response.data.unidades)
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleAgendamentoTipoChange(value) {
            this.form.municipios = []
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []
            this.model.municipioId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.status = null
            this.data = null

            const request = {
                listar: 'municipios',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                demandaTipo: this.model.demandaTipo,
                agendamentoTipoId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoConsulta.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.municipios = Object.assign(response.data.municipios)
                    this.form.unidades = Object.assign(response.data.unidades)
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleMunicipioChange(value) {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.status = null
            this.data = null

            const request = {
                listar: 'unidades',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                demandaTipo: this.model.demandaTipo,
                municipioId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoConsulta.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.unidades = Object.assign(response.data.unidades)
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.status = null
            this.data = null

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                demandaTipo: this.model.demandaTipo,
                municipioId: this.model.municipioId,
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoConsulta.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.status = null
            this.data = null

            const request = {
                listar: 'especialidades',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                demandaTipo: this.model.demandaTipo,
                municipioId: this.model.municipioId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoConsulta.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEspecialidadeChange(value) {
            this.form.usuarios = []
            this.form.status = []
            this.model.usuarioId = null
            this.model.status = null
            this.data = null

            const request = {
                listar: 'usuarios',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                demandaTipo: this.model.demandaTipo,
                municipioId: this.model.municipioId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoConsulta.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.form.status = []
            this.model.status = null
            this.data = null

            const request = {
                listar: 'status',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                demandaTipo: this.model.demandaTipo,
                municipioId: this.model.municipioId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: value,
            }

            this.setLoading()

            this.repositories.relatorioEstatisticoConsulta.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.status = Object.assign(response.data.status))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleStatusChange() {
            this.data = null
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
    },
    mixins: [error, file, repository, stringCase],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.demandaTipos = []
                this.form.agendamentoTipos = []
                this.form.municipios = []
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.especialidades = []
                this.form.usuarios = []
                this.form.status = []
                this.model.demandaTipo = null
                this.model.tipoId = null
                this.model.municipioId = null
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.especialidadeId = null
                this.model.usuarioId = null
                this.model.status = null
                this.data = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'demanda-tipos',
                    periodo: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioEstatisticoConsulta.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.demandaTipos = Object.assign(response.data.demandaTipos)
                        this.form.agendamentoTipos = Object.assign(response.data.agendamentoTipos)
                        this.form.municipios = Object.assign(response.data.municipios)
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.especialidades = Object.assign(response.data.especialidades)
                        this.form.usuarios = Object.assign(response.data.usuarios)
                        this.form.status = Object.assign(response.data.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>